import {Pipe, PipeTransform} from '@angular/core';
import {StorageUnitType} from '../../global/util/StorageUnitType';

@Pipe({
  name: 'storageUnitType'
})
export class StorageUnitTypePipe implements PipeTransform {

  transform(storageUnitType: number): string {
    switch (storageUnitType) {
      case StorageUnitType.KB:
        return 'KB';
      case StorageUnitType.MB:
        return 'MB';
      case StorageUnitType.GB:
        return 'GB';
      case StorageUnitType.TB:
        return 'TB';
      default:
        return 'PB';
    }
  }
}
